<template>
  <v-card-text class="title font-weight-light text-left">  

      <v-row v-if="info.options[0].value.length == 1" align="center" justify="center">
        <v-col cols="10" class="text-center">
          <u>Parte {{info.current}} de {{info.total}}</u>
        </v-col>
        <v-col cols="10" class="subtitle-2">
          Pon tu dedo indice izquierdo sobre la tecla <b>{{info.options[0].keyboard}}</b> y púlsalo para la categoría <span style="color:blue;">{{info.options[0].value[0]}}</span><br>
          Pon tu dedo indice derecho sobre la tecla <b>{{info.options[1].keyboard}}</b> y púlsalo para la categoría <span style="color:blue;">{{info.options[1].value[0]}}</span>
        </v-col>   
        <v-col cols="10" class="subtitle-2">
          En caso de equivocarte aparecerá el símbolo <v-icon color="red">mdi-close</v-icon>, por tanto pulsa la otra opción. <br>
          Haz el test tan rápido y preciso como puedas.
        </v-col>          
      </v-row>

      <v-row v-else align="center" justify="center">
        <v-col cols="10" class="text-center">
          <u>Part {{info.current}} of {{info.total}}</u>
        </v-col>
        <v-col cols="10" class="subtitle-2">
          Pon tu dedo indice izquierdo sobre la tecla <b>{{info.options[0].keyboard}}</b> y púlsalo para la categoría 
          <span style="color:blue;">{{info.options[0].value[0]}}</span> 
          <span v-if="info.options[0].value[0].length > 0 && info.options[0].value[1].length > 1"> o </span>
          <span style="color:green;">{{info.options[0].value[1]}}</span>
          <br>Pon tu dedo indice derecho sobre la tecla <b>{{info.options[1].keyboard}}</b> y púlsalo para la categoría 
          <span style="color:blue;">{{info.options[1].value[0]}}</span>
          <span v-if="info.options[1].value[0].length > 0 && info.options[1].value[1].length > 1"> o </span>
          <span style="color:green;">{{info.options[1].value[1]}}</span>
        </v-col>   
        <v-col cols="10" class="subtitle-2">
          En caso de equivocarte aparecerá el símbolo <v-icon color="red">mdi-close</v-icon>
  , por tanto pulsa la otra opción. <br>
          Haz el test tan rápido y preciso como puedas.
        </v-col>          
      </v-row>

  </v-card-text>
</template>

<script>

import { mdiClose } from '@mdi/js'


export default {
  name: 'CardTextInstructions',
  props: ['info'],
  data: () => ({
    }),
  };
</script>

<style>
.custom-card{
  font-family: auto;
}
.v-card__text{
  color: black !important;
}

</style>

